
 



 
 import {fs} from "Config/FsConfig";
 
    import CustomContentData from 'Modules/Aqs/Scripts/AppServiceContract/CustomContentData';


    //module CustomContentAppService {
    class CustomContentAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Aqs.AppService/CustomContentAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Aqs.AppService/CustomContentAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/?customcontentcode=${customcontentcode}
    //public static RouteLoadCustomContentFooter = (customcontentcode: string[]) => this.ServiceUrl + `modules/Aqs.AppServiceContract/CustomContentAppService/LoadCustomContentFooter`;
    public RouteLoadCustomContentFooter(customcontentcode: string[]) : string {
        return this.ControllerUrl + "/"+"LoadCustomContentFooter";
    }
    public LoadCustomContentFooter(customcontentcode: string[]): JQuery.jqXHR<CustomContentData[]> {
        return $.ajax({
                url: this.RouteLoadCustomContentFooter(customcontentcode),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(customcontentcode),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default CustomContentAppService;



